export default __webpack_public_path__ + "static/media/check.358a8414.svg";